var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "b-modal",
              rawName: "v-b-modal.worker-stats",
              modifiers: { "worker-stats": true }
            }
          ]
        },
        [_vm._v("Статистика")]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "worker-stats",
            "modal-class": "fullSizeModal",
            title: "Зарплата сотрудника " + _vm.userIdentity.username,
            size: "lg",
            "ok-only": ""
          }
        },
        [
          _c("date-filter", { attrs: { namespace: _vm.namespace } }),
          _vm._v(" "),
          _c("WorkerStats", {
            attrs: { namespace: _vm.namespace, role: _vm.userIdentity.role }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-336fe992", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-336fe992","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/WrapperWorkerStats.vue
// module id = null
// module chunks = 